module.exports = __webpack_public_path__ + "files/4db33abd9dbcd61d25d5d672f2ac4c7e.svg";